/*
 * Shared CM <-> IN converter for the size-chart tables.
 *
 * Used by all three surfaces that render snippets/lifted-size-table:
 *   - the PDP size-guide drawer        (sections/lifted-product.liquid)
 *   - the quick-buy modal size-guide   (snippets/lifted-quick-buy.liquid → bestsellers/collection/style-with)
 *   - the /pages size-chart page       (sections/lifted-size-chart.liquid)
 *
 * Each caller passes the element that holds the size <table>(s) + the target
 * unit. We snapshot every measurement cell's original CM text once (data-cm)
 * so flipping back to CM is exact, skip column 0 (size labels like 2XS/XS),
 * convert numbers cm -> in (/ 2.54), and relabel "(cm)" headers to "(in)".
 * Invoked only from click handlers, so a deferred load is fine.
 */
(function () {
  if (window.liftedSizeUnits) return;
  window.liftedSizeUnits = function (container, unit) {
    if (!container) return;
    container.querySelectorAll('table tr').forEach(function (tr) {
      Array.from(tr.children).forEach(function (cell, idx) {
        if (idx === 0) return; // size-label column — never convert
        if (!cell.dataset.cm) cell.dataset.cm = cell.textContent.trim(); // snapshot CM once
        var raw = cell.dataset.cm;
        cell.textContent = unit === 'in'
          ? raw.replace(/(\d+(?:[.,]\d+)?)/g, function (m) {
              var v = parseFloat(m.replace(',', '.'));
              return isFinite(v) ? (v / 2.54).toFixed(1).replace(/\.?0+$/, '') : m;
            }).replace(/\(cm\)/gi, '(in)')
          : raw;
      });
    });
  };
})();
